import { TUserState } from './model';

export const REDUCER_INIT_STATE: TUserState = {
  isLogged: false,
  isSubscribed: false,
  ipAddress: '',
  abTests: new Map<number, number>(),
  cart: '',
  sessionId: '',
  consent: '',
};
